import React from 'react';
import { ArrowRightIcon } from './Icons';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  subtext?: string;
}
export function CTAButton({
  children,
  className = '',
  subtext
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-425">
      <a href="#comprar" className="block w-full max-w-xl mx-auto bg-yellow-400 hover:bg-yellow-500 text-black font-montserrat font-black text-xl md:text-2xl py-5 px-6 rounded-xl transition-all text-center uppercase tracking-wide border-2 border-yellow-600 btn-shadow flex items-center justify-center gap-3" data-id="element-426">
        {children}
        <ArrowRightIcon className="w-6 h-6 md:w-8 md:h-8" strokeWidth={3} data-id="element-427" />
      </a>
      {subtext && <p className="mt-4 text-sm md:text-base text-gray-600 font-medium text-center flex items-center justify-center gap-2" data-id="element-428">
          🔒 {subtext}
        </p>}
    </div>;
}